import React, { useState } from "react";
import { adminApi } from "../../../../../../services";
import { useNavigate } from "react-router-dom";
import UserSearchCard from "../../../../../../components/common/UserSearchCard";

export default function CreateInsurance() {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [form, setForm] = useState({
    provider: "",
    type: "life",
    premiumAmount: "",
    coverageAmount: "",
    startDate: "",
    endDate: "",
  });


  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!user) {
      return alert("Please search user first");
    }
  
    try {
      const res = await adminApi.createInsurance({
        userId: user._id,
        ...form,
      });
  
      const createdInsurance = res?.data?.data;
  
      alert("Insurance created successfully");
  
      // ✅ PRINT FLOW
      if (window.confirm("Do you want to print the insurance details?")) {
        navigate("/admin-dashboard/print", {
          state: {
            type: "insurance",
            data: createdInsurance,
            returnTo: "/admin-dashboard/insurance"
          },
        });
      } else {
        navigate("/admin-dashboard/insurance");
      }
  
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to create Insurance");
    }
  };
  return (
    <div className="container">
      <h2>Create Insurance</h2>

      <UserSearchCard
        getUser={adminApi.getUserByAccountNumber}
        onUserFound={setUser}
      />

      {user && (
        <form onSubmit={handleSubmit} className="mt-3">
          <input className="form-control mb-2" placeholder="Provider"
            onChange={(e)=>setForm({...form, provider:e.target.value})} />

          <select className="form-control mb-2"
            onChange={(e)=>setForm({...form, type:e.target.value})}>
            <option value="life">Life</option>
            <option value="health">Health</option>
            <option value="vehicle">Vehicle</option>
          </select>

          <input className="form-control mb-2" placeholder="Premium"
            onChange={(e)=>setForm({...form, premiumAmount:e.target.value})} />

          <input className="form-control mb-2" placeholder="Coverage"
            onChange={(e)=>setForm({...form, coverageAmount:e.target.value})} />

          <input type="date" className="form-control mb-2"
            onChange={(e)=>setForm({...form, startDate:e.target.value})} />

          <input type="date" className="form-control mb-2"
            onChange={(e)=>setForm({...form, endDate:e.target.value})} />

          <button className="btn btn-primary w-100">Create Insurance</button>
        </form>
      )}
    </div>
  );
}
